'use client'
import { styled } from '../config'

export const TextAreaStyled = styled('textarea', {
  fontWeight: 400,
  border: 'none',
  outline: 'none',
  resize: 'none',
})
